import { Box, Text } from '@dixa/lib-shared-habla';

import { useAppDispatch } from 'utils/redux/useAppDispatch';
import { useAppSelector } from 'utils/redux/useAppSelector';

import { elevioActions } from '../../../elevio.actions';
import { elevioSelectors } from '../../../elevio.reducer/selectors';
import { getUrl } from '../../../utils';

import styles from './ResolutionModalBody.module.scss';

import { ResolutionDraftForm, ResolutionRadioInputs } from './index';

export function ResolutionDraftDialog(): JSX.Element {
  const dispatch = useAppDispatch();
  const draft = useAppSelector(elevioSelectors.resolution.draft);
  const conversationSubject = useAppSelector(
    elevioSelectors.conversation.subject,
  );
  const messages = useAppSelector(elevioSelectors.conversation.messages);

  const yesChecked = !!draft;
  const noChecked = draft === false;

  const setShouldCreateDraft = () => {
    if (conversationSubject) {
      dispatch(
        elevioActions.resolution.setNoSolutionDraftArticle({
          url: getUrl(),
          conversationSubject,
          messages,
        }),
      );
    }
  };
  const setShouldNotCreateDraft = () =>
    dispatch(elevioActions.resolution.setNoSolutionNoDraftArticle());

  return (
    <>
      <Box className={styles.section}>
        <Text.Paragraph subdued={true} className={styles.paragraph}>
          Would you like to create a draft article to use as a resolution for
          this conversation?
        </Text.Paragraph>
        <ResolutionRadioInputs
          name="shouldCreateDraft"
          noChecked={noChecked}
          onCheckNo={setShouldNotCreateDraft}
          onCheckYes={setShouldCreateDraft}
          yesChecked={yesChecked}
        />
      </Box>
      {draft && <ResolutionDraftForm />}
    </>
  );
}
